import React, { useRef } from 'react';
import { Box, Container, Typography, Link, Chip, Stack } from '@mui/material';
import { motion, useScroll, useTransform } from 'framer-motion';
import { LocalMallOutlined } from '@mui/icons-material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import new1 from '../../assets/new1.avif';
import new2 from '../../assets/new2.avif';
import new3 from '../../assets/new3.avif';
import new4 from '../../assets/new4.avif';
import new5 from '../../assets/new5.avif';
import new6 from '../../assets/new6.avif';
import new7 from '../../assets/new7.avif';
import new8 from '../../assets/new8.avif';

const products = [
    {
        title: "Elegant Silk Saree with Zari...",
        price: "₹10,499",
        category: "ETHNIC WEAR",
        image: new1,
        isHot: true
    },
    {
        title: "Boho Chic Floral Maxi Dress",
        price: "₹5,499",
        category: "CASUAL CHIC",
        image: new2,
        isHot: false
    },
    {
        title: "Contemporary Palazzo Suit Set",
        price: "₹8,250",
        category: "FESTIVE EDIT",
        image: new3,
        isHot: true
    },
    {
        title: "Classic Denim Jacket",
        price: "₹6,590",
        category: "WESTERN WEAR",
        image: new4,
        isHot: false
    },
    {
        title: "Embroidered Ethnic Wear",
        price: "₹9,190",
        category: "ETHNIC WEAR",
        image: new5,
        isHot: true
    },
    {
        title: "Designer Lehengas",
        price: "₹20,490",
        category: "FESTIVE EDIT",
        image: new6,
        isHot: false
    },
    {
        title: "Modern Kurta Set",
        price: "₹7,150",
        category: "ETHNIC WEAR",
        image: new7,
        isHot: true
    },
    {
        title: "Cotton Printed Suit",
        price: "₹4,590",
        category: "CASUAL CHIC",
        image: new8,
        isHot: false
    }
];

const ProductCard = ({ product }) => {
    return (
        <Box
            sx={{
                width: '100%',
                cursor: 'pointer',
                '&:hover .cart-button': {
                    opacity: 1,
                    transform: 'translateY(0)'
                }
            }}
        >
            <Box
                sx={{
                    position: 'relative',
                    width: '100%',
                    paddingTop: '138%', // Slightly reduced height from 140%
                    overflow: 'hidden',
                    borderRadius: '2px',
                    mb: 2,
                    backgroundColor: '#f5f5f5'
                }}
            >
                <Box
                    component="img"
                    src={product.image}
                    alt={product.title}
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        transition: 'transform 0.6s ease-in-out',
                        '&:hover': {
                            transform: 'scale(1.05)'
                        }
                    }}
                />
                {product.isHot && (
                    <Chip
                        label="HOT"
                        sx={{
                            position: 'absolute',
                            top: 16,
                            left: 16,
                            backgroundColor: 'white',
                            color: '#1a1a1a',
                            fontFamily: "'Sora', sans-serif",
                            fontWeight: 600,
                            fontSize: '0.65rem',
                            width: '55px',
                            height: '22px',
                            borderRadius: '0px',
                            '& .MuiChip-label': { px: 1 }
                        }}
                    />
                )}

                <Box
                    className="cart-button"
                    sx={{
                        position: 'absolute',
                        bottom: 20,
                        right: 20,
                        width: '45px',
                        height: '45px',
                        borderRadius: '50%',
                        border: '2px solid white',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: 'white',
                        color: 'black',
                        opacity: 0,
                        transform: 'translateY(10px)',
                        transition: 'all 0.3s ease-in-out',
                        '&:hover': {
                            backgroundColor: '#D4A0A6',
                            borderColor: '#D4A0A6',
                            color: 'white'
                        }
                    }}
                >
                    <LocalMallOutlined sx={{ fontSize: '1.2rem' }} />
                </Box>
            </Box>
            <Typography
                sx={{
                    fontFamily: "'cormorantgaramond', serif",
                    fontWeight: 700,
                    fontSize: '1.25rem',
                    color: '#1a1a1a',
                    mb: 0.5,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                }}
            >
                {product.title}
            </Typography>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Typography
                    sx={{
                        fontFamily: "'Sora', sans-serif",
                        fontWeight: 600,
                        fontSize: '0.9rem',
                        color: '#666'
                    }}
                >
                    {product.price}
                </Typography>
                <Typography
                    sx={{
                        fontFamily: "'Sora', sans-serif",
                        fontWeight: 600,
                        fontSize: '0.65rem',
                        color: '#999',
                        letterSpacing: '0.05em'
                    }}
                >
                    {product.category}
                </Typography>
            </Stack>
        </Box>
    );
};

const NewArrivals = () => {
    const targetRef = useRef(null);
    const { scrollYProgress } = useScroll({
        target: targetRef
    });

    const x = useTransform(scrollYProgress, [0, 1], ["0%", "-70%"]);

    return (
        <Box
            ref={targetRef}
            sx={{
                position: 'relative',
                height: '400vh',
                backgroundColor: 'transparent'
            }}
        >
            <Box
                sx={{
                    position: 'sticky',
                    top: 0,
                    height: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    overflow: 'hidden'
                }}
            >
                <Container maxWidth="xl" sx={{ position: 'relative' }}>
                    <Stack
                        direction={{ xs: 'column', md: 'row' }}
                        justifyContent="space-between"
                        alignItems={{ xs: 'flex-start', md: 'flex-end' }}
                        sx={{ mb: 6 }}
                        spacing={2}
                    >
                        <Box>
                            <Typography
                                variant="h2"
                                sx={{
                                    fontFamily: "'cormorantgaramond', serif",
                                    fontWeight: 800,
                                    fontSize: { xs: '2.5rem', md: '4rem' },
                                    color: '#1a1a1a',
                                    mb: 2
                                }}
                            >
                                New Arrivals
                            </Typography>
                            <Typography
                                sx={{
                                    fontFamily: "'Sora', sans-serif",
                                    fontSize: '1rem',
                                    color: '#666',
                                    maxWidth: '500px',
                                    lineHeight: 1.6
                                }}
                            >
                                Handpicked styles just for you, featuring the latest trends in ethnic and western fashion.
                            </Typography>
                        </Box>
                        <Link
                            href="#"
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                color: '#1a1a1a',
                                textDecoration: 'none',
                                fontFamily: "'Sora', sans-serif",
                                fontWeight: 600,
                                fontSize: '0.8rem',
                                letterSpacing: '0.1em',
                                textTransform: 'uppercase',
                                '&:hover': {
                                    gap: 1.5,
                                    transition: 'all 0.3s ease'
                                }
                            }}
                        >
                            VIEW ALL <ArrowForwardIcon sx={{ fontSize: '1rem' }} />
                        </Link>
                    </Stack>

                    <Box
                        component={motion.div}
                        initial={{ opacity: 0, x: 300 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true, amount: 0.4 }}
                        transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
                    >
                        <motion.div style={{ x, display: 'flex', gap: '32px' }}>
                            {products.map((product, index) => (
                                <Box
                                    key={index}
                                    sx={{
                                        flex: {
                                            xs: '0 0 280px',
                                            sm: '0 0 320px',
                                            lg: '0 0 380px'
                                        }
                                    }}
                                >
                                    <ProductCard product={product} />
                                </Box>
                            ))}
                        </motion.div>
                    </Box>
                </Container>
            </Box>
        </Box>
    );
};

export default NewArrivals;
